import { Platform } from '@angular/cdk/platform';
import { DOCUMENT } from '@angular/common';
import { AfterViewInit, ChangeDetectorRef, Component, HostListener, Inject, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { FuseNavigationService } from '@fuse/components/navigation/navigation.service';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { FuseConfigService } from '@fuse/services/config.service';
import { FuseSplashScreenService } from '@fuse/services/splash-screen.service';
import { environment } from 'environments/environment';
import * as moment from 'moment';
import { interval, Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import * as io from 'socket.io-client';
import { AppService } from './app.service';
import { Costanti, CostantiStorage } from './main/utils/costanti';
import { CommonService } from './main/utils/service/common.service';
import { NotificaService } from './main/utils/service/notifica.service';
import { ItalianMessagesService } from './main/utils/service/italian-messages.service';
import { UtentiService } from './main/utils/service/utente.service';
import { SessioneUtenteQuery, SessioneUtenteStore } from './main/utils/state';
import { Utils } from './main/utils/utils';
import { navigation } from './navigation/navigation';

@Component({
  standalone: false,
  selector: 'app',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  providers: [UtentiService, CommonService]
})
export class AppComponent implements OnInit, AfterViewInit, OnDestroy {
  private authenticationRetryTimer;
  TIMEINTERVALUPDATECHECK = 1 * 60 * 1000;
  fuseConfig: any;
  navigation: any;
  isSafari: boolean;
  isPolicyAccepted: boolean;
  isInLogin: boolean;

  // Private
  private _unsubscribeAll: Subject<any>;
  promptInstallEvent;
  devtools = {
    open: false,
    orientation: null
  };
  threshold = 160;
  checkInterval;
  emitEvent = function (state, orientation) {
    window.dispatchEvent(
      new CustomEvent('devtoolschange', {
        detail: {
          open: state,
          orientation: orientation
        }
      })
    );
  };
  screenHeight: number;
  screenWidth: number;

  isApp: boolean;
  timeInterval;
  @HostListener('window:navTrigger', ['$event'])
  onNavTrigger($event) {
    if ($event.detail && this.sessioneUtenteQuery.isLoggedIn()) {
      const generateActualToken = idUtente => {
        const baseTimestamp = moment('1993-07-07').unix() * 1000;
        return Utils.SHA256(Utils.SHA256(`${idUtente}@${baseTimestamp}`));
      };

      let url: string = $event.detail.url;
      const auth: string = $event.detail.auth;
      const expectedAuth: string = generateActualToken(this.sessioneUtenteQuery.loggedUser().id);
      if (auth != expectedAuth) return;
      if (!url.startsWith('/')) url = `/${url}`;
      this.router.navigateByUrl(url);
    }
  }

  @HostListener('window:pageshow', ['$event'])
  onPageShow(event: PageTransitionEvent): void {
    if (event.persisted) {
      // Re-bootstrap Angular after a browser bfcache restore.
      window.location.reload();
    }
  }

  private isPaypalReturn(): boolean {
    const hash = window.location.hash || '';
    if (!/^#\/dls\/abbonamento(?:\?|$)/.test(hash)) {
      return false;
    }

    const params = new URLSearchParams(window.location.search || '');
    const hashQueryIndex = hash.indexOf('?');
    const hashParams = hashQueryIndex >= 0 ? new URLSearchParams(hash.slice(hashQueryIndex + 1)) : null;
    return !!(params.get('token') || (hashParams && hashParams.get('token')));
  }

  private handlePaypalReturn(): void {
    if (!this.isPaypalReturn()) {
      return;
    }

    const cleanUrl = `${window.location.origin}${window.location.pathname}${(window.location.hash || '').split('?')[0]}`;
    const currentState = window.history.state || {};
    window.history.replaceState({ ...currentState, paypalReturn: true }, document.title, cleanUrl);
  }

  constructor(
    @Inject(DOCUMENT) private document: any,
    private _fuseConfigService: FuseConfigService,
    private _fuseNavigationService: FuseNavigationService,
    private _fuseSidebarService: FuseSidebarService,
    private _fuseSplashScreenService: FuseSplashScreenService,
    private italianMessages: ItalianMessagesService,
    private _platform: Platform,
    private swUpdate: SwUpdate,
    private utenteService: UtentiService,
    public appService: AppService,
    public sessioneUtenteStore: SessioneUtenteStore,
    public sessioneUtenteQuery: SessioneUtenteQuery,
    private router: Router,
    private cd: ChangeDetectorRef,
    private notificaService: NotificaService
  ) {
    this.navigation = navigation;
    this.epicFunction();
    this.updateClient();
    this.checkUpdate();
    this.isApp = Utils.isApp();

    this.appService.onPrivacyPolicyChange.subscribe(status => {
      this.isPolicyAccepted = status;
    });

    // Register the navigation to the service
    this._fuseNavigationService.register('main', this.navigation);

    // Set the main navigation as our current navigation
    this._fuseNavigationService.setCurrentNavigation('main');

    // Add is-mobile class to the body if the platform is mobile
    if (this._platform.ANDROID || this._platform.IOS) {
      this.document.body.classList.add('is-mobile');
    }

    // Set the private defaults
    this._unsubscribeAll = new Subject();
    window.addEventListener('beforeinstallprompt', event => {
      this.promptInstallEvent = event;
    });
    // window.addEventListener('appinstalled', evt => {
    //   this.promptInstallEvent.prompt();
    // });
    // router.events.subscribe(val => {
    //   if (val instanceof NavigationEnd) {
    //     console.log(val);

    //     const loggedId = this.sessioneUtenteQuery.loggedUser() ? this.sessioneUtenteQuery.loggedUser().id : -1;
    //     const hidden = loggedId === -1;
    //     this._fuseConfigService.setConfig({
    //       layout: {
    //         navbar: { hidden: hidden },
    //         navigation: { hidden: hidden },
    //         toolbar: { hidden: hidden },
    //         footer: { hidden: hidden }
    //       }
    //     });
    //     // this.pagina = this.route.snapshot.queryParams.pagina;
    //   }
    // });
    // if (environment.production) {
    //   swUpdate.available.subscribe(event => {
    //     console.log('Updating to new version...');
    //     window.location.reload(true);
    //   });
    //   if (this.swUpdate.isEnabled) {
    //     this.swUpdate.available.subscribe(() => {
    //       window.location.reload(true);
    //     });
    //   } else {
    //     console.log('Nessun update');
    //   }
    // }
    if (!Costanti.TRADUZIONI['SUCCESS']) {
      Costanti.TRADUZIONI['SUCCESS'] = this.italianMessages.instant('TOAST.successo');
      Costanti.TRADUZIONI['ERROR'] = this.italianMessages.instant('TOAST.errore');
      Costanti.TRADUZIONI['TITOLO'] = '';
    }
    window.addEventListener('devtoolschange', event => {
      if (event['detail']) {
        if (event['detail'].open) {
          // this.utenteService
          //   .logTool()
          //   .pipe(takeUntil(this._unsubscribeAll))
          //   .subscribe(data => {
          //     clearInterval(this.checkInterval);
          //   });
        }
      }
    });

    this.sessioneUtenteQuery.isLoggedIn$.pipe(takeUntil(this._unsubscribeAll)).subscribe(yes => {
      const socket = this.appService.notificationSocket;
      if (yes) {
        if (!socket) {
          const notificationSocket = io.connect(Costanti.APIURL);
          this.appService.notificationSocket = notificationSocket;
          let authenticationFailed = false;
          let authenticationRetryable = false;
          let authenticationRetryDelay = 5000;
          notificationSocket.on('authentication_failed', () => {
            authenticationFailed = true;
            authenticationRetryable = false;
          });
          notificationSocket.on('authentication_error', () => {
            authenticationRetryable = true;
          });
          notificationSocket.on('authentication_timeout', () => {
            authenticationRetryable = true;
          });
          notificationSocket.on('authenticated', () => {
            authenticationRetryDelay = 5000;
          });
          notificationSocket.on('disconnect', reason => {
            if (reason === 'io server disconnect' && authenticationRetryable && !authenticationFailed) {
              authenticationRetryable = false;
              const retryDelay = authenticationRetryDelay;
              authenticationRetryDelay = Math.min(authenticationRetryDelay * 2, 60000);
              this.authenticationRetryTimer = setTimeout(() => {
                if (
                  this.appService.notificationSocket === notificationSocket &&
                  this.sessioneUtenteQuery.isLoggedIn() &&
                  localStorage.getItem(CostantiStorage.TOKEN)
                ) {
                  notificationSocket.connect();
                }
              }, retryDelay);
            }
          });
          notificationSocket.on('authenticate', () => {
            const token = localStorage.getItem(CostantiStorage.TOKEN);
            if (token) {
              notificationSocket.emit('authenticate', { Authorization: `Bearer ${token}` });
            } else {
              notificationSocket.disconnect();
              if (this.appService.notificationSocket === notificationSocket) {
                this.appService.notificationSocket = null;
              }
            }
          });
          notificationSocket.on('notification', data => {
            const myId = this.sessioneUtenteQuery.loggedUser().id;
            if (data.to.includes(myId)) {
              this.notificaService.checkNotifiche.next(true);
              if (data.type === 'new_export_massivo') {
                this.appService.onReloadExportMassivo.next(true);
              }
            }
          });
        }
      } else {
        if (socket) {
          clearTimeout(this.authenticationRetryTimer);
          socket.disconnect();
          this.appService.notificationSocket = null;
        }
      }
    });
  }

  updateClient() {
    if (!this.swUpdate.isEnabled) {
      console.warn('Not Enabled');
      return;
    }
    this.swUpdate.versionUpdates.subscribe(event => {
      if (event.type !== 'VERSION_READY') {
        return;
      }
      console.warn(`current`, event.currentVersion, `available `, event.latestVersion);
      console.warn('Update presente aggiorno la PWA');
      this.swUpdate.activateUpdate().then(() => document.location.reload());
    });
  }
  checkUpdate() {
    if (this.timeInterval) {
      return;
    }
    if (!this.swUpdate.isEnabled) {
      console.warn('Not Enabled');
      return;
    }
    this.timerUpdateTick();
    this.timeInterval = interval(this.TIMEINTERVALUPDATECHECK);

    console.warn('TIMER INIT');
    this.timeInterval.subscribe(() => {
      this.timerUpdateTick();
    });
  }
  timerUpdateTick() {
    if (!this.swUpdate.isEnabled) {
      console.warn('Not Enabled');
      return;
    }
    console.warn('TIMER TICK ', new Date().toString());
    this.swUpdate.checkForUpdate().then(() => console.warn('checked'));
    console.warn('update checked');
  }
  epicFunction() {
    const isTablet = /iPad|Tablet|Android(?!.*Mobile)/i.test(window.navigator.userAgent);
    if (this._platform.SAFARI) {
      this.document.body.classList.add('is-safari');
      this.appService.setState('isSafari', true);
    }
    if (this._platform.ANDROID) {
      this.document.body.classList.add('is-android');
      this.appService.setState('isAndroid', true);
    }
    if (isTablet) {
      this.document.body.classList.add('is-tablet');
      this.appService.setState('isTablet', true);
    }
    if (this._platform.ANDROID || this._platform.IOS) {
      this.document.body.classList.add('is-mobile');
      this.appService.setState('isMobile', true);
    }
  }

  setEvento() {
    const that = this;
  }
  forceSWupdate() {
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker.getRegistrations().then(registrations => {
        for (let registration of registrations) {
          console.log('[UPDATE]', registration);
          registration.update();
        }
      });
    }
  }
  ngOnInit(): void {
    this.setEvento();
    if (!this.sessioneUtenteQuery.isLoggedIn()) {
      console.log('non logged');
      localStorage.setItem(CostantiStorage.URLPRELOGOUT, window.location.href);
      this.sessioneUtenteStore.login(JSON.parse(localStorage.getItem(CostantiStorage.STATE)));
      localStorage.removeItem(CostantiStorage.STATE);
      if (this.sessioneUtenteQuery.loggedUser()) {
        this.appService.onPrivacyPolicyChange.next(!!this.sessioneUtenteQuery.loggedUser().privacy);
      }
    } else {
      if (this.sessioneUtenteQuery.loggedUser()) {
        this.appService.onPrivacyPolicyChange.next(!!this.sessioneUtenteQuery.loggedUser().privacy);
      }
    }

    this.handlePaypalReturn();

    this.router.events.subscribe(_ => {
      localStorage.setItem(CostantiStorage.CURRENTURL, window.location.href);
    });

    this.router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe((e: NavigationEnd) => {
      this.isInLogin = e.urlAfterRedirects.includes('login') || e.urlAfterRedirects.includes('logout');
    });

    if (localStorage.getItem(CostantiStorage.PRIVACYACCEPTED) != undefined) {
      this.appService.onPrivacyPolicyChange.next(true);
    }

    this.appService.onReloadMenu.pipe(takeUntil(this._unsubscribeAll)).subscribe(dta => {
      if (localStorage.getItem(CostantiStorage.TOKEN) !== null) {
        this.checkMenu();
      }
    });
    // Subscribe to config changes
    this._fuseConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.fuseConfig = config;

      if (this.fuseConfig.layout.width === 'boxed') {
        this.document.body.classList.add('boxed');
      } else {
        this.document.body.classList.remove('boxed');
      }
    });
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHander(event) {
    if (environment.production) {
      // this.sessioneUtenteStore.logout();
      // this.utenteService.logout().subscribe(data => {
      //   localStorage.removeItem(CostantiStorage.TOKEN);
      //   return true;
      // });
    } else {
      localStorage.setItem(CostantiStorage.STATE, JSON.stringify(this.sessioneUtenteQuery.loggedUser()));
      return true;
    }
  }

  ngOnDestroy(): void {
    clearTimeout(this.authenticationRetryTimer);
    const socket = this.appService.notificationSocket;
    if (socket) {
      socket.removeAllListeners();
      socket.disconnect();
      this.appService.notificationSocket = null;
    }
    this._unsubscribeAll.next(undefined);
    this._unsubscribeAll.complete();
  }

  ngAfterViewInit() {
    this.cd.detectChanges();
  }

  toggleSidebarOpen(key): void {
    this._fuseSidebarService.getSidebar(key).toggleOpen();
  }

  toggleVisibility() {
    this.appService.setState('screenLocked', false);
  }

  checkMenu() {
    if (this._fuseNavigationService.getIsSetMenu() === false) {
      if (localStorage.getItem(CostantiStorage.TOKEN)) {
        // this.utenteService
        //   .getMenu()
        //   .pipe(takeUntil(this._unsubscribeAll))
        //   .subscribe(data => {
        //     if (data) {
        this._fuseNavigationService.setIsSetMenu(true);
        this._fuseNavigationService.setMenu(null);
        this._fuseNavigationService.setCurrentNavigation('main');
        //   }
        // });
      }
    }
  }

  setPolicyOk() {
    this.appService.onPrivacyPolicyChange.next(true);
    localStorage.setItem(CostantiStorage.PRIVACYACCEPTED, 'true');
    try {
      this.utenteService.setAccettazionePrivacy().subscribe();
    } catch (e) {}
  }
}
